<template>
  <div class="py-3">
    <v-card class="rounded_max mb-2" elevation="1">
      <div>
        <h3 class="mb-2 text-center">GPA Management</h3>
      </div>
      <v-tabs centered color="green" slider-size="4" v-model="tab">
        <v-tab class="text-capitalize"> <b>Submission</b> </v-tab>
        <v-tab class="text-capitalize"> <b>Scholar GPA</b> </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items v-model="tab" style="background: none">
      <v-tab-item class="pa-1">
        <ManageIPSubmission />
      </v-tab-item>
      <v-tab-item class="pa-1">
        <ManageIPScholar />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ManageIPScholar from "./manageIPScholar.vue";
import ManageIPSubmission from "./manageIPSubmission.vue";
export default {
  name: "listScholarSubmission",
  components: { ManageIPSubmission, ManageIPScholar },
  data() {
    return {
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      tab: null,
      find: "",
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        {
          text: "ID",
          align: "start",
          value: "no_tf",
        },
        {
          text: "Submitted Date",
          align: "start",
          value: "updated_at",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/scholar?page[number]=${this.page}&page[size]=${this.limit}&filter[search]=${this.find}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
